(function(){
  'use strict';

  angular
    .module('app.products')
    .component('productCard', productCardComponent());

  function productCardComponent() {
    return {
      template: `
        <div class="product-card" ng-class="{'product-card--with-cta': vm.ctaButton}">
          <div class="product-card__figure">
            <img class="product-card__figure__image" ng-src="{{vm.image}}" alt="">
          </div>
          <div class="product-card__content">
            <div class="product-card__title" ng-bind-html="vm.name | wrapLastWord"></div>
            <div class="product-card__description">
              {{vm.description}}
            </div>
            <div class="product-card__actions" ng-if="vm.ctaButton">
              <a href="#" class="button button--total-width button--outline">{{vm.ctaButton}} <i class="fa fa-arrow-circle-o-right"></i></a>
            </div>
          </div>
        </div>
      `,
      bindings: {
        name: '=',
        description: '=?',
        slug: '=',
        image: '=',
        ctaButton: '=?'
      },
      controller: ProductCardController,
      controllerAs: 'vm',
      transclude: false
    }
  }

  function ProductCardController() {
    let vm = this;

    vm.$onInit = () => {
      if(vm.ctaButton == undefined) vm.ctaButton = `Conheça ${vm.name}`;
    }

  }

})();
